import { render, staticRenderFns } from "./TheTeam.vue?vue&type=template&id=04e29ea0&scoped=true&"
import script from "./TheTeam.vue?vue&type=script&lang=ts&"
export * from "./TheTeam.vue?vue&type=script&lang=ts&"
import style0 from "./TheTeam.vue?vue&type=style&index=0&id=04e29ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e29ea0",
  null
  
)

export default component.exports